import React, { useState } from "react";
import postImage from "../../../images/no-image.png";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { HiUser, HiGift, HiLocationMarker, HiMail, HiX } from 'react-icons/hi';

const CardTile = ({ familiesData, hof, current_hof }) => {
  const [imageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  let navigate = useNavigate();
  
  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setImageModal(true);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setImageModal(false);
  };

  const cardData = [];
  const filteredData = hof
    ? familiesData.filter((fHead) => fHead?._id === hof)
    : familiesData.filter(
        (family) => family?.primary_member_id?._id === current_hof
      );

  const headOfFamily = filteredData[0]?.primary_member_id;

  cardData.push({
    id: headOfFamily?._id,
    title: headOfFamily?.first_name + " " + headOfFamily?.last_name,
    image: headOfFamily?.image,
    email: headOfFamily?.email,
    date_of_birth: headOfFamily?.date_of_birth,
    birth_place: headOfFamily?.birth_place,
    role: "Head of Family"
  });

  filteredData?.forEach((item) => {
    const memberData = item.family_member;
    memberData?.forEach((mItem) => {
      let lastName = mItem.member_id?.last_name ?? "";
      cardData.push({
        id: mItem._id,
        title: mItem.member_id.first_name + " " + lastName,
        image: mItem.image,
        email: mItem.member_id.email,
        date_of_birth: mItem.date_of_birth,
        birth_place: mItem.birth_place,
        role: "Family Member"
      });
    });
  });

  return (
    <>
      {/* Image Modal */}
      {imageModal && (
        <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-75" onClick={closeImageModal}>
          <div className="relative mx-4 w-full max-w-4xl">
            <button 
              className="absolute top-4 right-4 text-white transition-colors duration-200 hover:text-gray-300"
              onClick={closeImageModal}
            >
              <HiX className="w-8 h-8" />
            </button>
            <img
              src={selectedImage}
              alt="Member"
              className="w-full h-auto rounded-lg"
              crossOrigin="anonymous"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {cardData?.length ? (
          cardData.map((card, index) => (
            <div
              key={index}
              className="overflow-hidden bg-white rounded-xl shadow-sm transition-all duration-300 hover:shadow-md"
            >
              <div className="p-6">
                <div className="flex flex-col items-center">
                  {/* Profile Image */}
                  <div className="relative group">
                    <div className="overflow-hidden w-32 h-32 bg-gray-100 rounded-full ring-4 ring-gray-50">
                      {card?.image?.length ? (
                        <img
                          crossOrigin="anonymous"
                          src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/family/${card.image}`}
                          className="object-cover w-full h-full transition-transform duration-300 cursor-pointer group-hover:scale-110"
                          alt={card.title}
                          onClick={() => openImageModal(`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/family/${card.image}`)}
                        />
                      ) : (
                        <div className="flex justify-center items-center w-full h-full">
                          <HiUser className="w-16 h-16 text-gray-300" />
                        </div>
                      )}
                    </div>
                    {card.role === "Head of Family" && (
                      <div className="absolute -top-1 -right-1">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                          Head of Family
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Member Info */}
                  <div className="mt-4 text-center">
                    <h3 className="font-semibold text-gray-900">{card?.title}</h3>
                    {!card?.email?.includes("randomemail.com") && (
                      <div className="flex justify-center items-center mt-1 space-x-1 text-sm text-gray-500">
                        <HiMail className="w-4 h-4" />
                        <span>{card?.email}</span>
                      </div>
                    )}
                  </div>

                  {/* Additional Info */}
                  <div className="mt-6 space-y-4">
                    {card?.date_of_birth && (
                      <div className="flex items-center space-x-3 text-gray-500">
                        <div className="flex justify-center items-center w-8 h-8 bg-gray-50 rounded-lg">
                          <HiGift className="w-5 h-5" />
                        </div>
                        <span className="text-sm">
                          {dayjs(card?.date_of_birth).format("MMMM D, YYYY")}
                        </span>
                      </div>
                    )}
                    
                    {card?.birth_place && (
                      <div className="flex items-center space-x-3 text-gray-500">
                        <div className="flex justify-center items-center w-8 h-8 bg-gray-50 rounded-lg">
                          <HiLocationMarker className="w-5 h-5" />
                        </div>
                        <span className="text-sm">{card?.birth_place}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full">
            <div className="flex flex-col justify-center items-center p-8 bg-white rounded-xl shadow-sm">
              <HiUser className="w-16 h-16 text-gray-300" />
              <h3 className="mt-4 text-lg font-semibold text-gray-900">No Family Members</h3>
              <p className="mt-1 text-gray-500">There are no family members to display.</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CardTile;
